"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MigrationsApi = exports.MigrationsApiFactory = exports.MigrationsApiFp = exports.MigrationsApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * MigrationsApi - axios parameter creator
 * @export
 */
const MigrationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} migrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationsResourceClearAllLogs: (migrationId_1, ...args_1) => __awaiter(this, [migrationId_1, ...args_1], void 0, function* (migrationId, options = {}) {
            // verify required parameter 'migrationId' is not null or undefined
            (0, common_1.assertParamExists)('migrationsResourceClearAllLogs', 'migrationId', migrationId);
            const localVarPath = `/migrations/{migrationId}/logs`
                .replace(`{${"migrationId"}}`, encodeURIComponent(String(migrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} migrationId
         * @param {boolean} [dryRun]
         * @param {{ [key: string]: string; } | null} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationsResourceDoMigrationImmediate: (migrationId_2, dryRun_1, requestBody_1, ...args_2) => __awaiter(this, [migrationId_2, dryRun_1, requestBody_1, ...args_2], void 0, function* (migrationId, dryRun, requestBody, options = {}) {
            // verify required parameter 'migrationId' is not null or undefined
            (0, common_1.assertParamExists)('migrationsResourceDoMigrationImmediate', 'migrationId', migrationId);
            const localVarPath = `/migrations/{migrationId}/immediate`
                .replace(`{${"migrationId"}}`, encodeURIComponent(String(migrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (dryRun !== undefined) {
                localVarQueryParameter['dry-run'] = dryRun;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} migrationId
         * @param {string | null} [filter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationsResourceGetLogs: (migrationId_3, filter_1, ...args_3) => __awaiter(this, [migrationId_3, filter_1, ...args_3], void 0, function* (migrationId, filter, options = {}) {
            // verify required parameter 'migrationId' is not null or undefined
            (0, common_1.assertParamExists)('migrationsResourceGetLogs', 'migrationId', migrationId);
            const localVarPath = `/migrations/{migrationId}/logs`
                .replace(`{${"migrationId"}}`, encodeURIComponent(String(migrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} migrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationsResourceGetMigrationData: (migrationId_4, ...args_4) => __awaiter(this, [migrationId_4, ...args_4], void 0, function* (migrationId, options = {}) {
            // verify required parameter 'migrationId' is not null or undefined
            (0, common_1.assertParamExists)('migrationsResourceGetMigrationData', 'migrationId', migrationId);
            const localVarPath = `/migrations/{migrationId}/data`
                .replace(`{${"migrationId"}}`, encodeURIComponent(String(migrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} migrationId
         * @param {boolean} [dryRun]
         * @param {{ [key: string]: string; } | null} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationsResourceSubmitMigration: (migrationId_5, dryRun_2, requestBody_2, ...args_5) => __awaiter(this, [migrationId_5, dryRun_2, requestBody_2, ...args_5], void 0, function* (migrationId, dryRun, requestBody, options = {}) {
            // verify required parameter 'migrationId' is not null or undefined
            (0, common_1.assertParamExists)('migrationsResourceSubmitMigration', 'migrationId', migrationId);
            const localVarPath = `/migrations/{migrationId}`
                .replace(`{${"migrationId"}}`, encodeURIComponent(String(migrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (dryRun !== undefined) {
                localVarQueryParameter['dryRun'] = dryRun;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.MigrationsApiAxiosParamCreator = MigrationsApiAxiosParamCreator;
/**
 * MigrationsApi - functional programming interface
 * @export
 */
const MigrationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.MigrationsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} migrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationsResourceClearAllLogs(migrationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.migrationsResourceClearAllLogs(migrationId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MigrationsApi.migrationsResourceClearAllLogs']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} migrationId
         * @param {boolean} [dryRun]
         * @param {{ [key: string]: string; } | null} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationsResourceDoMigrationImmediate(migrationId, dryRun, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.migrationsResourceDoMigrationImmediate(migrationId, dryRun, requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MigrationsApi.migrationsResourceDoMigrationImmediate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} migrationId
         * @param {string | null} [filter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationsResourceGetLogs(migrationId, filter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.migrationsResourceGetLogs(migrationId, filter, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MigrationsApi.migrationsResourceGetLogs']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} migrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationsResourceGetMigrationData(migrationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.migrationsResourceGetMigrationData(migrationId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MigrationsApi.migrationsResourceGetMigrationData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} migrationId
         * @param {boolean} [dryRun]
         * @param {{ [key: string]: string; } | null} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationsResourceSubmitMigration(migrationId, dryRun, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.migrationsResourceSubmitMigration(migrationId, dryRun, requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MigrationsApi.migrationsResourceSubmitMigration']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.MigrationsApiFp = MigrationsApiFp;
/**
 * MigrationsApi - factory interface
 * @export
 */
const MigrationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.MigrationsApiFp)(configuration);
    return {
        /**
         *
         * @param {MigrationsApiMigrationsResourceClearAllLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationsResourceClearAllLogs(requestParameters, options) {
            return localVarFp.migrationsResourceClearAllLogs(requestParameters.migrationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MigrationsApiMigrationsResourceDoMigrationImmediateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationsResourceDoMigrationImmediate(requestParameters, options) {
            return localVarFp.migrationsResourceDoMigrationImmediate(requestParameters.migrationId, requestParameters.dryRun, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MigrationsApiMigrationsResourceGetLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationsResourceGetLogs(requestParameters, options) {
            return localVarFp.migrationsResourceGetLogs(requestParameters.migrationId, requestParameters.filter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MigrationsApiMigrationsResourceGetMigrationDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationsResourceGetMigrationData(requestParameters, options) {
            return localVarFp.migrationsResourceGetMigrationData(requestParameters.migrationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MigrationsApiMigrationsResourceSubmitMigrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationsResourceSubmitMigration(requestParameters, options) {
            return localVarFp.migrationsResourceSubmitMigration(requestParameters.migrationId, requestParameters.dryRun, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
    };
};
exports.MigrationsApiFactory = MigrationsApiFactory;
/**
 * MigrationsApi - object-oriented interface
 * @export
 * @class MigrationsApi
 * @extends {BaseAPI}
 */
class MigrationsApi extends base_1.BaseAPI {
    /**
     *
     * @param {MigrationsApiMigrationsResourceClearAllLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationsApi
     */
    migrationsResourceClearAllLogs(requestParameters, options) {
        return (0, exports.MigrationsApiFp)(this.configuration).migrationsResourceClearAllLogs(requestParameters.migrationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MigrationsApiMigrationsResourceDoMigrationImmediateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationsApi
     */
    migrationsResourceDoMigrationImmediate(requestParameters, options) {
        return (0, exports.MigrationsApiFp)(this.configuration).migrationsResourceDoMigrationImmediate(requestParameters.migrationId, requestParameters.dryRun, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MigrationsApiMigrationsResourceGetLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationsApi
     */
    migrationsResourceGetLogs(requestParameters, options) {
        return (0, exports.MigrationsApiFp)(this.configuration).migrationsResourceGetLogs(requestParameters.migrationId, requestParameters.filter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MigrationsApiMigrationsResourceGetMigrationDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationsApi
     */
    migrationsResourceGetMigrationData(requestParameters, options) {
        return (0, exports.MigrationsApiFp)(this.configuration).migrationsResourceGetMigrationData(requestParameters.migrationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MigrationsApiMigrationsResourceSubmitMigrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationsApi
     */
    migrationsResourceSubmitMigration(requestParameters, options) {
        return (0, exports.MigrationsApiFp)(this.configuration).migrationsResourceSubmitMigration(requestParameters.migrationId, requestParameters.dryRun, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.MigrationsApi = MigrationsApi;
//# sourceMappingURL=migrations-api.js.map